import { Box, Card, Typography } from "@mui/material";
import React from "react";
import ClaimCardStyles from "./PopperClaimCardStyles";

const PopperClaimCard = ({ item }: any) => {
  return (
    <div>
      <Card sx={ClaimCardStyles.claimCard}>
        <Box sx={ClaimCardStyles.containerOne}>
          <Box>
            <Typography sx={ClaimCardStyles.claimCardItemHeading}>
              {item?.number}
            </Typography>
            <Typography sx={ClaimCardStyles.claimCartItemContent}>
              Claim Number
            </Typography>
          </Box>
          <Box>
            <Typography sx={ClaimCardStyles.claimCardItemHeading}>
              {item?.productName}
            </Typography>
            <Typography sx={ClaimCardStyles.claimCartItemContent}>
              Product Name
            </Typography>
          </Box>
          <Box>
            <Typography sx={ClaimCardStyles.claimCardItemHeading}>
              {item?.status}
            </Typography>
            <Typography sx={ClaimCardStyles.claimCartItemContent}>
              Status
            </Typography>
          </Box>
        </Box>
      </Card>
    </div>
  );
};

export default PopperClaimCard;
